<div class="reviews" [ngClass]="{ 'reviews--nocontrols': !showControls }">
    <div class="reviews__carousel" #reviewCarousel>
        <ng-container *ngIf="reviewsToDisplay.length; else singleReview">
            <out-carousel
                timing="500ms cubic-bezier(0.645, 0.045, 0.355, 1)"
                [showControls]="showControls"
                [isMobile]="itemsInView === 1"
                [autoPlay]="false"
            >
                <!-- Button Prev -->
                <ng-container buttonPrev>
                    <div class="reviews__button reviews__button--prev">
                        <svg class="svg-icon svg-icon--xs">
                            <use href="assets/icons-ui.svg#links-open"></use>
                        </svg>
                    </div>
                </ng-container>

                <!-- Button Next -->
                <ng-container buttonNext>
                    <div class="reviews__button reviews__button--next">
                        <svg class="svg-icon svg-icon--xs">
                            <use href="assets/icons-ui.svg#rechts-open"></use>
                        </svg>
                    </div>
                </ng-container>

                <!-- Items -->
                <ng-container items>
                    <out-carousel-item *ngFor="let review of reviewsToDisplay">
                        <!-- Item -->
                        <div class="review-balloon review-balloon--short" [ngStyle]="{ width: itemWidth }">
                            <div class="review-balloon__balloon">
                                <div class="review-balloon__score">
                                    {{ review.score }}
                                </div>
                                <div class="review-balloon__content">
                                    <div class="review-balloon__wrap">
                                        <div class="h3 review-balloon__name">
                                            {{ review.naam }}
                                        </div>
                                        <span class="review-balloon__date">
                                            {{ review.beoordelingstijd_omschrijving }}
                                        </span>
                                        <p>{{ review.testimonial }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- / Item -->
                    </out-carousel-item>
                </ng-container>
                <!-- Items -->
            </out-carousel>
        </ng-container>
    </div>
</div>

<ng-template #singleReview>
    <div class="carousel" *ngIf="reviews && reviews[0]">
        <div class="review-balloon">
            <div class="review-balloon__balloon">
                <div class="review-balloon__score">
                    {{ reviews[0].score }}
                </div>
                <div class="review-balloon__content">
                    <div class="review-balloon__wrap">
                        <div class="h3 review-balloon__name">{{ reviews[0].naam }}</div>
                        <span class="review-balloon__date">{{ reviews[0].beoordelingstijd_omschrijving }}</span>
                        <p>{{ reviews[0].testimonial }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
